import axios from 'axios'
import { i18n } from '../../plugins/i18n'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues
} from '../../modules/mutations.js'
import { toBase64Url } from '../../modules/convertUrlToBase64'
import { castAttributesForCamelCase, castAttributesForSnakeCase } from 'src/biz_spa/modules/string_converter'
import { menuCategories } from 'src/biz_spa/domains/foodMenu/consts'

const initData = () => ({
  food: {
    sections: [],
  },
  lunch: {
    sections: [],
  },
  drink: {
    sections: [],
  },
  takeout: {
    sections: [],
  },
  label: '',
  targetServices: [],
})
const initFormValues = () => ({
  stores: []
})

export const companiesFoodMenu = {
  namespaced: true,
  state: {
    data: initData(),
    formValues: initFormValues(),
    serverServiceTypes: [],
    loading: false
  },
  getters: {
    storeTotalCount(state) {
      return state.formValues.stores.length
    },
  },
  mutations: {
    setTargetServices(state, payload) {
      state.data.targetServices = payload
    },
    initNewFoodMenu(state) {
      state.data = initData()
      state.formValues = initFormValues()
      state.serverServiceTypes = []
    },
    apiConnect(state) {
      state.loading = true
    },
    readFoodMenuSuccess(state, payload) {
      const result = castAttributesForCamelCase(payload.data)

      menuCategories.forEach(category => {
        result[category] = { sections: [] }
        result[category].sections = result.sections.filter(v => v.category === category)
        result[category].sections.forEach(section => {
          section.key = `${category}-section-${section.sortOrder}`
          section.items
            .forEach(item => {
              item.key = `${category}-section-${section.sortOrder}-item-${item.sortOrder}`
              if(item.imageUrl) {
                toBase64Url(item.imageUrl, function (base64Url) {
                  item.filename = 'filename.jpg'
                  item.content = base64Url
                })
              }
            })
        })
      })
      delete result.sections
      state.data = result
      state.formValues.stores = result.storeUuids
      state.serverServiceTypes = result.targetServices

      state.loading = false
    },
    apiSuccess(state) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
    addSection(state, { sectionData }) {
      const INITIAL_SECTION_KEY = 'section-1'
      const INITIAL_ITEM_KEY = 'section-1-item-1'
      if(state.data[sectionData.category].sections.length === 0){
        sectionData.sortOrder = 1
        sectionData.key = INITIAL_SECTION_KEY
        sectionData.items[0].key = INITIAL_ITEM_KEY
        state.data[sectionData.category].sections.push(sectionData)
      } else {
        const maxOrder = Math.max.apply(null, state.data[sectionData.category].sections.map(section => section.sortOrder))
        sectionData.sortOrder = maxOrder + 1
        sectionData.key = `section-${maxOrder + 1}`
        sectionData.items[0].key = `section-${maxOrder + 1}-item-1`
        state.data[sectionData.category].sections.push(sectionData)

      }

    },
    updateSection(state, { key, label, description, category }) {
      const targetSection = state.data[category].sections.find(section => section.key === key)
      targetSection.label = label
      targetSection.description = description
    },
    deleteSection(state, { key, category }) {
      const targetSection = state.data[category].sections.find(section => section.key === key)
      state.data[category].sections = state.data[category].sections.filter(section => section.key !== key)
      state.data[category].sections.forEach(section => {
        if (section.sortOrder < targetSection.sortOrder) return
        section.sortOrder = section.sortOrder - 1
      })
      targetSection.items.forEach(item => {
        item.isImageDelete = true
      })
    },
    addItem(state, { item, section }) {
      const targetSection = state.data[section.category].sections.find(v => v.key === section.key)
      const maxOrder = Math.max.apply(null, targetSection.items.map(item => item.sortOrder))
      item.sortOrder = maxOrder + 1
      item.key = `${section.key}-item-${maxOrder + 1}`
      targetSection.items.push(item)
    },
    updateItem(state, { item, section }) {
      const targetSection = state.data[section.category].sections.find(v => v.key === section.key)
      const targetItem = targetSection.items.find(v => v.key === item.key)
      targetItem.label = item.label
      targetItem.price = item.price
      targetItem.description = item.description
      targetItem.isRecommend = item.isRecommend
      targetItem.imageId = item.imageId
      targetItem.filename = item.filename
      targetItem.imageUrl = item.imageUrl
      targetItem.isImageDelete = item.isImageDelete
    },
    deleteItem(state, { section, item: { key } }) {
      const targetSection = state.data[section.category].sections.find(v => v.key === section.key)
      const targetItemOrder = targetSection.items.find(item => item.key === key).sortOrder
      targetSection.items = targetSection.items.filter(item => item.key !== key)
      targetSection.items.forEach(item => {
        if (item.sortOrder < targetItemOrder) return
        item.sortOrder = item.sortOrder - 1
      })
    },
    moveSectionTop(state, { key, category }) {
      const targetSectionOrder = state.data[category].sections.find(section => section.key === key).sortOrder
      state.data[category].sections.forEach(section => {
        if (section.sortOrder > targetSectionOrder) return
        const order = section.key === key ? 1 : section.sortOrder + 1
        section.sortOrder = order
      })
    },
    moveSectionOneUp(state, { key, category }) {
      const targetSection = state.data[category].sections.find(section => section.key === key)
      if (targetSection.sortOrder === 1) return
      state.data[category].sections.find(section => section.sortOrder === targetSection.sortOrder - 1).sortOrder += 1
      targetSection.sortOrder -= 1
    },
    moveSectionOneDown(state, { key, category }) {
      const targetSection = state.data[category].sections.find(section => section.key === key)
      const maxOrder = Math.max.apply(null, state.data[category].sections.map(section => section.sortOrder))
      if(targetSection.sortOrder === maxOrder) return
      if (targetSection.sortOrder === maxOrder) return
      state.data[category].sections.find(section => section.sortOrder === targetSection.sortOrder + 1).sortOrder -= 1
      targetSection.sortOrder += 1
    },
    moveSectionBottom(state, { key, category }) {
      const targetSectionOrder = state.data[category].sections.find(section => section.key === key).sortOrder
      const maxOrder = Math.max.apply(null, state.data[category].sections.map(section => section.sortOrder))
      state.data[category].sections.forEach(section => {
        if (section.sortOrder < targetSectionOrder) return
        const order = section.key === key ? maxOrder : section.sortOrder - 1
        section.sortOrder = order
      })
    },
    moveItemTop(state, { section: { key: sectionKey, category }, item: { key: itemKey } }) {
      const targetSection = state.data[category].sections.find(section => section.key === sectionKey)
      const targetItemOrder = targetSection.items.find(item => item.key === itemKey).sortOrder
      targetSection.items.forEach(item => {
        if (item.sortOrder > targetItemOrder) return
        const order = item.key === itemKey ? 1 : item.sortOrder + 1
        item.sortOrder = order
      })
    },
    moveItemBottom(state, { section: { key: sectionKey, category }, item: { key: itemKey } }) {
      const targetSection = state.data[category].sections.find(section => section.key === sectionKey)
      const targetItemOrder = targetSection.items.find(item => item.key === itemKey).sortOrder
      const maxOrder = Math.max.apply(null, targetSection.items.map(item => item.sortOrder))
      targetSection.items.forEach(item => {
        if (item.sortOrder < targetItemOrder) return
        const order = item.key === itemKey ? maxOrder : item.sortOrder - 1
        item.sortOrder = order
      })
    },
    moveItemOneUp(state, { section: { key: sectionKey, category }, item: { key: itemKey } }) {
      const targetSection = state.data[category].sections.find(section => section.key === sectionKey)
      const targetItem = targetSection.items.find(item => item.key === itemKey)
      if (targetItem.sortOrder === 1) return
      targetSection.items.find(item => item.sortOrder === targetItem.sortOrder - 1).sortOrder += 1
      targetItem.sortOrder -= 1
    },
    moveItemOneDown(state, { section: { key: sectionKey, category }, item: { key: itemKey } }) {
      const targetSection = state.data[category].sections.find(section => section.key === sectionKey)
      const targetItem = targetSection.items.find(item => item.key === itemKey)
      const maxOrder = Math.max.apply(null, targetSection.items.map(item => item.sortOrder))
      if (targetItem.sortOrder === maxOrder) return
      targetSection.items.find(item => item.sortOrder === targetItem.sortOrder + 1).sortOrder -= 1
      targetItem.sortOrder += 1
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues
  },
  actions: {
    readFoodMenu({ commit, rootState }, id) {
      commit('apiConnect')
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/food_menus/${id}`)
        .then(res => {
          commit('readFoodMenuSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    duplicateFoodMenu({ commit, rootState }, id) {
      commit('apiConnect')
      return axios
        .post(`/api/companies/${rootState.route.params.company_uuid}/food_menu_duplicates`, {food_menu_id: id})
        .then(res => {
          commit('apiSuccess')
          commit('readFoodMenuSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    createFoodMenu({ commit, rootState }, payload) {
      const params = castAttributesForSnakeCase(payload)

      commit('apiConnect')
      return axios
        .post(`/api/companies/${rootState.route.params.company_uuid}/food_menus`, params)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.created', { value: i18n.t('models.foodMenu.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    updateFoodMenu({ commit, rootState }, { id, payload }) {
      const params = castAttributesForSnakeCase(payload)

      commit('apiConnect')
      return axios
        .patch(`/api/companies/${rootState.route.params.company_uuid}/food_menus/${id}`, params)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.foodMenu.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    async uploadFoodMenuItemImage({ commit, rootState }, image) {
      commit('apiConnect')
      return await new Promise((resolve) => {
        const reader = new FileReader()

        reader.readAsDataURL(image)

        reader.onload = async () => {
          const image_payload = {
            image: {
              content: reader.result,
              filename: image.name,
            }
          }

          await axios
            .post(`/api/companies/${rootState.route.params.company_uuid}/food_menu/item/images`, image_payload)
            .then(res => {
              commit('apiSuccess')
              const resData = {
                id: res.data.data.id,
                name: image.name,
                url: res.data.data.url,
                content: reader.result,
              }
              resolve(resData)
            }).catch(err => {
              commit('apiFailure')
              commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
              console.error(err)
            })
        }
      })
    },
    async deleteFoodMenuItemImage({ commit, rootState }, imageId) {
      commit('apiConnect')
      await axios
        .delete(`/api/companies/${rootState.route.params.company_uuid}/food_menu/item/images/${imageId}`)
        .then(() => {
          commit('apiSuccess')
          return true
        }).catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    }
  }
}

